<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">

            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <div class="form-group">  
                <label class="label-required" >ประเภทตัวแทนจำหน่าย:</label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline"> 
                      <label class="kt-radio"  v-show="IS_RADIO_SHOW_AGENT">
                        <input
                          type="radio"
                          id="apmrAgentTypeCode"
                          name="AGENT_TYPE_CODE"
                          value="AGENT"
                          v-model="apmrAgentTypeCode"
                          ref="apmrAgentTypeCode" 
                            @change="onApmrAgentTypeCodeChange(this)"
                           
                        />
                        <span></span>
                        ตัวแทนจำหน่าย 
                      </label>
                      <label class="kt-radio" v-show="IS_RADIO_SHOW_SUB_AGENT"> 
                        <input
                          type="radio"
                          id="apmrAgentTypeCode"
                          name="AGENT_TYPE_CODE"
                          value="SUB_AGENT"
                          v-model="apmrAgentTypeCode"
                          ref="apmrAgentTypeCode" 
                            @change="onApmrAgentTypeCodeChange(this)"
                             
                        />
                        <span></span>
                        ตัวแทนจำหน่ายย่อย
                      </label>
                       
                    </div>
                  </div>
                </div>
              </div> 
            </div>

            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <div class="form-group">
                <label class="label-required">ประเภท:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'apmrTypeCode'"
                  :name="'apmrTypeCode'"
                  :select2-options="apmrTypeCodeOptions"
                  v-model="apmrTypeCode"
                  ref="apmrTypeCodeSelect2"
                  @selectChange="onApmrTypeCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">วันที่:</label>
                <div class="input-group date">
                  <input
                    readonly
                    :disabled="isEdit"
                    type="text"
                    class="form-control"
                    placeholder="(วว/ดด/ปปปป)"
                    id="apmrDate"
                    name="apmrDate"
                    ref="apmrDate"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="la la-calendar-check-o"></i>
                    </span>
                  </div>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="apmrAgentTypeCode=='AGENT'">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่าย :</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrAgentCode'"
                  :name="'apmrAgentCode'"
                  :select2-options="apmrAgentCodeOptions"
                  v-model="apmrAgentCode"
                  ref="apmrAgentCodeSelect2"
                  @selectChange="onApmrAgentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ร้านค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrShopCodes'"
                  :name="'apmrShopCodes'"
                  :select2-options="apmrShopCodesOptions"
                  v-model="apmrShopCodes"
                  ref="apmrShopCodesSelect2"
                  multiple
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!---sub agent-->
          <div class="row" v-show="apmrAgentTypeCode=='SUB_AGENT'">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่ายย่อย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrSubAgentCode'"
                  :name="'apmrSubAgentCode'"
                  :select2-options="apmrSubAgentCodeOptions"
                  v-model="apmrSubAgentCode"
                  ref="apmrSubAgentCodeSelect2"
                  @selectChange="onApmrSubAgentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrSubShopCodes'"
                  :name="'apmrSubShopCodes'"
                  :select2-options="apmrSubShopCodesOptions"
                  v-model="apmrSubShopCodes"
                  ref="apmrSubShopCodesSelect2"
                  multiple
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!-- end sub agent -->
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ชื่อรูท:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="ชื่อรูท"
                  id="apmrRouteName"
                  name="apmrRouteName"
                  ref="apmrRouteName"
                  v-model="apmrRouteName"
                />
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ผู้ดำเนินการ:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'apmrPmUserId'"
                  :name="'apmrPmUserId'"
                  :select2-options="apmrPmUserIdOptions"
                  v-model="apmrPmUserId"
                  ref="apmrPmUserIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input type="checkbox" class="form-check-input" name="apmrInActiveStatus" id="apmrInActiveStatus" v-model="apmrInActiveStatus" />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)"><i class="la la-close"></i> ย้อนกลับ</button>
        <button type="submit" class="btn btn-primary"><i class="la la-save"></i> บันทึกข้อมูล</button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;

    var is_super_admin = self.$root.canShow(["super_admin"]) || self.$root.canShow(["ADMIN_PM"])  ;
    var is_agent_admin_pm = self.$root.canShow(["AGENT_ADMIN_PM"])  ;
    var is_sub_agent_admin_pm = self.$root.canShow(["SUB_AGENT_ADMIN_PM"])  ; 

    return {
      apmrTypeCode: null,
      apmrDate: null,
      apmrAgentCode: null,
      apmrSubAgentCode : null,
      apmrShopCodes: [],
      apmrSubShopCodes : [],
      apmrRouteName: null,
      apmrPmUserId: null,
      apmrInActiveStatus: true,
      apmrAgentTypeCode : is_agent_admin_pm ?  "AGENT"  :   "SUB_AGENT",
      isEdit: false,
      IS_RADIO_SHOW_AGENT : (is_agent_admin_pm || is_super_admin) ? true :  false ,
      IS_RADIO_SHOW_SUB_AGENT : (is_super_admin || is_sub_agent_admin_pm) ? true : false, 

      // Configurations
      apmrTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      apmrAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย"  ,
        allowClear: true,
        ajax: {
          url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              agentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      apmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },  
      apmrSubShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              shopCodes  : self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      apmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: null,//self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },   
      apmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
  
            var query = {
              agentTypeCode  : self.apmrAgentTypeCode ,
              agentCodes: self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              subAgentCodes: self.apmrSubAgentCode != null ? [self.apmrSubAgentCode] : null,
              IS_SUPER_ADMIN :  self.$root.canShow(["super_admin"]),
              IS_AGENT_ADMIN_PM : self.$root.canShowExSuperAdmin(["AGENT_ADMIN_PM"]),
              IS_SUB_AGENT_ADMIN_PM : self.$root.canShowExSuperAdmin(["SUB_AGENT_ADMIN_PM"]), 
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      axios
        .post("/Api/PM/RoutePlan/Add", {
          AgentCode: this.apmrAgentCode,
          TypeCode: this.apmrTypeCode,
          RoutePlanDate: this.apmrDate.format("DD/MM/YYYY"),
          ShopCodes: this.apmrShopCodes,
          RouteName: this.apmrRouteName,
          PmUserId: this.apmrPmUserId,
          InActiveStatus: !this.apmrInActiveStatus,
 
          SubAgentCode: this.apmrSubAgentCode,
          SubAgentShopCodes: this.apmrSubShopCodes,
          AgentTypeCode: this.apmrAgentTypeCode, 
        })
        .then(function(response) {
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              router.go(-1), self.$parent.reloadDataTable(false);
            });
          } else {
            //console.log(response);
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onApmrTypeCodeChange: function(id, text, data, ref) {
      var self = this;
      if (text != "") {
        if (text == "PM_TYPE_ADHOC") {
          self.apmrDate = moment();
          self.isEdit = true;
        } else if (text == "PM_TYPE_ROUTE_PLAN") {
          self.apmrDate = moment().add(1, "days");
          self.isEdit = false;
        }

        $(self.$refs.apmrDate)
          .datepicker("setStartDate", self.apmrDate.format("DD/MM/YYYY"))
          .datepicker("update", !!self.apmrDate ? self.apmrDate.format("DD/MM/YYYY") : null)
          .on("changeDate", function(e) {
            self.apmrDate = e.dates.length != 0 ? moment(e.date) : null;
          });
      }
    },
    onApmrAgentTypeCodeChange : function(obj){
     
      var self = this; 
      
      this.apmrAgentCode = null; 
      $("#apmrAgentCode")
      .val("")
      .trigger("change"); 

      this.apmrShopCodes = [];  
      $("#apmrShopCodes")
        .val("")
        .trigger("change");  


      this.apmrSubAgentCode = []; 
      $("#apmrSubAgentCode")
      .val("")
      .trigger("change");

      this.apmrSubShopCodes = null; 
      $("#apmrSubShopCodes")
      .val("")
      .trigger("change");

       
        
    },
    onApmrAgentCodeChange() {

      this.apmrShopCodes = [];  
      $("#apmrShopCodes")
        .val("")
        .trigger("change"); 

      this.apmrPmUserId = null; 
      $("#apmrPmUserId")
        .val("")
        .trigger("change");


      // this.apmrSubAgentCode = []; 
      // $("#apmrSubAgentCode")
      // .val("")
      // .trigger("change");

     
    },
    onApmrSubAgentCodeChange: function(id, text, data, ref) { 

      var self = this;  
      if(data[0]!=undefined){ 
        this.apmrAgentCode = data[0].data ;
      } 
      // this.apmrShopCodes = [];  
      // $("#apmrShopCodes")
      //   .val("")
      //   .trigger("change"); 

      this.apmrPmUserId = null; 
      $("#apmrPmUserId")
        .val("")
        .trigger("change"); 

        this.apmrSubShopCodes = []; 
      $("#apmrSubShopCodes")
      .val("")
      .trigger("change");
     },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.apmrDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      startDate: moment().format("DD/MM/YYYY"), // Current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.apmrDate)
      .datepicker("update", !!self.apmrDate ? self.apmrDate.format("DD/MM/YYYY") : null)
      .on("changeDate", function(e) {
        self.apmrDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        apmrTypeCode: "required",
        apmrDate: "required",
        apmrAgentCode: "required",
        apmrShopCodes: "required",
        apmrRouteName: "required",
        apmrPmUserId: "required", 
        apmrSubAgentCode: "required",
        apmrSubShopCodes: "required",
      },
      messages: {
        apmrTypeCode: "กรุณาเลือกประเภท",
        apmrDate: "กรุณาเลือกวันที่",
        apmrAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        apmrShopCodes: "กรุณาเลือกร้านค้า",
        apmrSubAgentCode: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
        apmrSubShopCodes: "กรุณาเลือกร้านค้า",
        apmrRouteName: "กรุณากรอกชื่อรูท",
        apmrPmUserId: "กรุณาเลือกผู้ดำเนินการ",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/PM/AddPMRoutePlan.vue